import React from "react";
// import { useNavigate } from "react-router-dom";

const Contact = () => {

  return (
    <>
      <div className="row gx-0">
        <div className="col-md-8 m-auto mt-5 text-center" id="contactPg">
          <h2> Let's work together </h2>
          <p className="text-muted">
            Walk me through your idea or simply say hi!
          </p>
          <form action="https://formspree.io/f/mjvzwyyg" method="post">
          <div className="row gx-0 my-4">
            <div className="col-md-7 m-auto">
              <div className="row gx-0">
                <div className="col-md-6 px-3 mb-2">
                  <div className="">
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        class="form-control"
                        id="floatingInputname"
                        placeholder="Enter Name"
                        name="name"
                        required
                      />
                      <label for="floatingInputname">Enter Name</label>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 px-3 mb-2">
                  <div className="">
                    <div class="form-floating mb-3">
                      <input
                        type="email"
                        class="form-control"
                        id="floatingInput"
                        name="email"
                        placeholder="name@example.com"
                        required
                      />
                      <label for="floatingInput">Email address</label>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 px-3 mb-2">
                  <div className="">
                    <div class="form-floating">
                      <textarea
                        class="form-control"
                        placeholder="Leave a comment here"
                        id="floatingTextarea2"
                        name="message"
                        style={{height: "100px"}}
                        required
                      ></textarea>
                      <label for="floatingTextarea">Enter Your Message</label>
                    </div>
                  </div>
                </div>

                <div>
                    <button className="navBtnLinks px-5" type="submit"> Submit </button>
                </div>
              </div>
            </div>
          </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Contact;
